export const NetworkContextName = "Avalanche testnet";
export const ACTIVE_NETWORK = 43113;
export const RPC_URL = "https://api.avax-test.network/ext/bc/C/rpc"; //testnet
export const creteAssest = "0x13652567d18258BCA6FE1b43893841aBE8198aCd";
export const marketplace = "0x802f0a832579F548DDcC35e7dBac6db2169b6F07";
export const nftCurrency = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
export const toeknAddress = "0x352E9437E5403fc580FE6dA999289D4696bF9b7a";
export const chatContrectAddress = "0xdB3ceFaD0aAC9d7a2524Ff49259B47b049cc4D11";
export const userDataContrectAddress =
  "0x244927aaD7b69f547f9695b46726FF368536066F";
export const tokenName = "AVT";
export const depositCoinName = "INR";

export const NetworkDetails = [
  {
    chainId: "0xa869",
    chainName: "Avalanche testnet",
    nativeCurrency: {
      name: "AVAX",
      symbol: "AVAX",
      decimals: 18,
    },
    rpcUrls: [RPC_URL],
    blockExplorerUrls: ["https://testnet.snowtrace.io/"],
  },
];

/////////-------mainnet--------////////

// export const NetworkContextName = "Avalanche Mainnet";
// export const ACTIVE_NETWORK = 43114;
// export const RPC_URL = "https://api.avax.network/ext/bc/C/rpc"; //mainnet

// export const NetworkDetails = [
//   {
//     chainId: "0xa86a",
//     chainName: "Avalanche Mainnet",
//     nativeCurrency: {
//       name: "AVAX",
//       symbol: "AVAX",
//       decimals: 18,
//     },
//     rpcUrls: [RPC_URL],
//     blockExplorerUrls: ["https://snowtrace.io/"],
//   },
// ];

export const dummydata = [
  {
    VanderReward: [
      {
        name: "Rohit Kumar",
        points: "20",
        date: "13th June 2022 13:09",
        des: "lorem ipsum dummy.....",
      },
      {
        name: "Rohit Kumar",
        points: "20",
        date: "13th June 2022 13:09",
        des: "lorem ipsum dummy.....",
      },
      {
        name: "Rohit Kumar",
        points: "20",
        date: "13th June 2022 13:09",
        des: "lorem ipsum dummy.....",
      },
      {
        name: "Rohit Kumar",
        points: "20",
        date: "13th June 2022 13:09",
        des: "lorem ipsum dummy.....",
      },
      {
        name: "Rohit Kumar",
        points: "20",
        date: "13th June 2022 13:09",
        des: "lorem ipsum dummy.....",
      },
      {
        name: "Rohit Kumar",
        points: "20",
        date: "13th June 2022 13:09",
        des: "lorem ipsum dummy.....",
      },
    ],
  },
  {
    productdata: [
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
      {
        product: "P12343",
        category: "Animal Food",
        subcategory: "Raw Flesh",
        productname: "Pedigree",
        interestedclient: "10",
        date: "13 Dec. 2022 13:30",
        approvestatus: "Approved",
        status: "Active",
      },
    ],
  },
];
